import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import Storage from '@core/utils/storage';
import { Store } from '@ngrx/store';
import { refreshSuccess } from '@core/store/actions/login.actions';
import jwtDecode from 'jwt-decode';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import KazooRes from '@core/models/gopon-res.model';
import { LoginRes } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private baseUrl = environment.API_BASE_URL + 'Account/';
  RefreshTokenUrl = this.baseUrl + 'RefreshToken';
  constructor(private readonly http: HttpClient, private store: Store) {}
  refreshToken(): Observable<LoginRes> {
    return this.http.post<any>(this.RefreshTokenUrl, null).pipe(
      tap((res) => {
        this.store.dispatch(refreshSuccess({ payload: res }));
      })
    );
  }
  isTokenExpired(): boolean {
    try {
      // Decode the token and retrieve the expiration time
      const decodedToken: any = jwtDecode(this.getAccessToken());
      const expirationDate: Date = new Date(decodedToken.exp * 1000);

      // console.log('token expired: ', new Date() > expirationDate);
      // Check if the current date is greater than the expiration date
      return false;//note here I will always return valid to depend on server respose only
      //return new Date() > expirationDate;
    } catch (error) {
      // If there's an error while decoding the token, consider it expired
      return true;
    }
  }

  getRefreshToken(): string {
    return Storage.get('core', null)?.login?.authorization?.Customer?.RToken;
  }
  getAccessToken(): string {
    const core = JSON.parse(JSON.stringify(Storage.get('core', '')));
    return core?.login?.authorization?.Customer?.Token;
  }
}
